import { CSSProperties } from 'react'

export const styles: { [key: string]: CSSProperties } = {

    panel: {
        paddingTop: "50px",
        paddingBottom: "50px",
    },

    lightPanel: {
        backgroundColor: "rgb(246, 246, 246)",
        color: "rgb(23, 23, 23)"
    },

    mediumPanel: {
        backgroundColor: "rgb(228, 228, 228)",
        color: "rgb(23, 23, 23)"
    },

};